<template>
  <div id="authority-hospital">
    <h3 class="title">权威医院</h3>
    <ul class="hospital-list">
      <li
        @mouseover="mouseOver(item.id)"
        @mouseleave="mouseLeave(item.id)"
        class="item"
        v-for="item of hospitalList"
        :key="item.id"
      >
        <img :src="item.imgUrl" alt="" />
        <div class="up-pull" :ref="'item' + item.id">
          <h3 class="hospital-name">{{ item.name }}</h3>
          <h4 class="rank">{{ item.rank }}</h4>
          <p class="detail" v-if="false">{{ item.detail }}</p>
        </div>
      </li>
    </ul>
    <!--<div class="video">
      <h3 class="title">对海外治疗陪同服务讲解视频</h3>
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </div>-->
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
export default {
  name: "AuthorityHospital",
  components: { videoPlayer },
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "http://vjs.zencdn.net/v/oceans.mp4" //url地址
          }
        ],
        poster: require("../../../../assets/images/blueCross/viedoImage.png"), //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      hospitalList: [
        {
          id: 1,
          name: "MD安德森癌症中心",
          rank: "全美肿瘤专科排名NO: 1",
          detail: "巴拉巴拉巴小魔仙！！！变变变",
          imgUrl: require("../../../../assets/images/blueCross/hospital1.png")
        },
        {
          id: 2,
          name: "梅奥诊所",
          rank: "全美综合医院排名NO: 1",
          detail: "巴拉巴拉巴小魔仙！！！变变变",
          imgUrl: require("../../../../assets/images/blueCross/hospital2.png")
        },
        {
          id: 3,
          name: "波士顿儿童医院",
          rank: "全美儿童综合医院排名NO: 1",
          detail: "巴拉巴拉巴小魔仙！！！变变变",
          imgUrl: require("../../../../assets/images/blueCross/hospital3.png")
        },
        {
          id: 4,
          name: "克利夫兰医院",
          rank: "心脏专科排名NO: 1",
          detail: "巴拉巴拉巴小魔仙！！！变变变",
          imgUrl: require("../../../../assets/images/blueCross/hospital4.png")
        }
      ]
    };
  },
  mounted() {},
  methods: {
    mouseOver(id) {
      this.$refs["item" + id][0].style.height = "175px";
    },
    mouseLeave(id) {
      this.$refs["item" + id][0].style.height = "52px";
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
#authority-hospital {
  margin-top: 40px;
  overflow: hidden;
  margin-bottom: 50px;
  .title {
    color: #535353;
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 30px;
  }
  .hospital-list {
    display: flex;
    .item {
      cursor: pointer;
      flex: 1;
      height: 207px;
      background: #d2d2d2;
      margin-right: 35px;
      position: relative;
      .up-pull {
        width: 100%;
        position: absolute;
        bottom: 0;
        background: rgba(181, 181, 181, 0.8);
        height: 52px;
        color: #ffffff;
        .hospital-name {
          margin: 10px 0;
          font-size: 16px;
          text-align: center;
        }
        .rank {
          margin: 10px 0;
          font-size: 12px;
          text-align: center;
        }
      }
      &:last-child {
        margin-right: 0;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .video {
    margin-top: 52px;
    height: 644px;
    width: 100%;
  }
}
</style>
